<script>
    export let ybId;
    export let ybWidgetTheme;
</script>

{#if (ybId && !isNaN(ybId))}
    <iframe 
        src={'https://yandex.ru/sprav/widget/rating-badge/' + ybId + '?type=rating&' + ( ybWidgetTheme === 'dark' ? 'theme=dark' : '' )} 
        width="150" 
        height="50" 
        frameborder="0"
        style="border-radius: 5px; overflow: hidden;"
    ></iframe>
{/if} 
